import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sender-dialog',
  templateUrl: './sender-dialog.component.html',
  styleUrls: ['./sender-dialog.component.scss'],
})
export class SenderDialogComponent implements OnInit {
  @Input() mode: string;

  @Input() email: string;
  @Input() phoneNumber: string;

  modeTxt: string;

  constructor(private modal: NgbActiveModal) {
    this.canSend();
  }

  ngOnInit() {
    this.modeTxt = this.mode == 'email' ? 'Email' : 'Phone Number';
  }

  send() {
    let recepient = this.mode == 'email' ? this.email : this.phoneNumber;
    this.modal.close({ data: recepient });
  }

  close() {
    this.modal.close(false);
  }

  canSend() {
    return (
      (this.mode == 'email' && this.email != '') ||
      (this.mode == 'phoneNumber' && this.phoneNumber != '')
    );
  }
}
